import React from 'react';
import TouchableBounce from 'utils/packages/TouchableBounce';
import useColors from 'hooks/useColors';
import { rem } from './values';
import Squircle from './Squircle';
const CheckBox = ({ value, onValueChange, style, hitSlop, testID, }) => {
    const colors = useColors();
    return (<TouchableBounce onPress={() => {
            onValueChange(!value);
        }} style={style} hitSlop={hitSlop} testID={testID} accessibilityRole="checkbox" accessibilityState={{
            checked: value,
        }}>
      <Squircle height={rem(24)} width={rem(24)} color={value ? colors.text.brand : colors.cards.transparentOnDark}>
        <Squircle height={rem(21)} width={rem(21)} color={value ? colors.background.light : colors.background.dark}>
          {value ? (<Squircle height={rem(14)} width={rem(14)} color={colors.text.brand}/>) : null}
        </Squircle>
      </Squircle>
    </TouchableBounce>);
};
export default CheckBox;
